<template>
<div>
  <div class="content-header">
    <div class="container-fluid">
      <div class="row mb-2">
        <div class="col-sm-6">
          <b-skeleton width="40%" height="2.5em"></b-skeleton>
        </div>
      </div>
    </div>
  </div>
  <section class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-6">
          <div class="info-box">
            <b-skeleton
              class="info-box-icon elevation-1"
            ></b-skeleton>

            <div class="info-box-content">
              <b-skeleton width="80%" class="info-box-text"></b-skeleton>
              <b-skeleton width="50%" class="info-box-number"></b-skeleton>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="info-box mb-3">
            <b-skeleton
              class="info-box-icon elevation-1"
            ></b-skeleton>

            <div class="info-box-content">
              <b-skeleton width="80%" class="info-box-text"></b-skeleton>
              <b-skeleton width="50%" class="info-box-number"></b-skeleton>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="info-box mb-3">
            <b-skeleton
              class="info-box-icon elevation-1"
            ></b-skeleton>

            <div class="info-box-content">
              <b-skeleton width="80%" class="info-box-text"></b-skeleton>
              <b-skeleton width="50%" class="info-box-number"></b-skeleton>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="info-box mb-3">
            <b-skeleton
              class="info-box-icon elevation-1"
            ></b-skeleton>

            <div class="info-box-content">
              <b-skeleton width="80%" class="info-box-text"></b-skeleton>
              <b-skeleton width="50%" class="info-box-number"></b-skeleton>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <section class="col-lg-12 connectedSortable">
          <div class="card">
            <!-- <div class="card-header">
              <h3 class="card-title d-flex w-100">
                <b-skeleton width="50%" height="21px"></b-skeleton>
              </h3>
            </div> -->
            <div class="card-body">
              <div class="tab-content p-0">
                <b-skeleton-img width="100%" height="300px" no-aspect></b-skeleton-img>
              </div>
            </div>
          </div>
        </section>
        <section class="col-lg-5 connectedSortable"></section>
      </div>
    </div>
  </section>
</div>
</template>

<script>
export default {
  name: "DashboardSkeleton",
};
</script>

<style scoped>
.h3-skeleton {
  height: 43px !important;
  margin-bottom: 0.5rem !important;
}
.info-box-icon {
  width: 70px;
  height: 64px;
}
</style>